/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesRecruitment {
	APPROVED_CANDIDATES = "res://senior.com.br/hcm/recruitment/successfulCandidatesConsideringHierachy",//ok
	MEDIUM_HIRING_TIME = "res://senior.com.br/hcm/recruitment/hiringAverageTimePortlet",
	MEDIUM_HIRING_TIME_LEADER = "res://senior.com.br/hcm/recruitment/leaderHiringAverageTimePortlet", //ok
	VACANCY_BY_MONTH = "res://senior.com.br/hcm/recruitment/vacancyFinishedTotalPortlet",
	LEADER_VACANCIES_BY_MONTH = "res://senior.com.br/hcm/recruitment/leaderVacancyFinishedTotalPortlet",
	MY_OPEN_VACANCY_TOTAL_PORTLET = "res://senior.com.br/hcm/recruitment/myOpenVacancyTotalPortlet",
	CURRICULUM_AMOUNT = "res://senior.com.br/hcm/recruitment/resumeTotalPortlet",
	INTERNAL_VACANCIES = "res://senior.com.br/hcm/recruitment/internalVacancies",
	STAFF_REQUISITION_SITUATION = "res://senior.com.br/hcm/recruitment/staffRequisitionSituation",
	FLOW_PROCESS = "res://senior.com.br/hcm/recruitment/flowProcess",
	MY_CANDIDATURES = "res://senior.com.br/hcm/recruitment/myInternalCandidatures",

	VIEW_VACANCY = "res://senior.com.br/hcm/vacancymanagement/entities/vacancy",
	VIEW_VACANCY_PUBLICATION = "res://senior.com.br/hcm/vacancymanagement/entities/vacancyPublication",
	MANAGE_VACANCIES_BY_HIERARCHY = "res://senior.com.br/hcm/vacancymanagement/manageVacanciesByHierarchy"
}

/**
 * Cards da página Manager, aba Recruitment
 */
export enum PermissionResourcesRecruitmentManager {
	APPROVED_CANDIDATES = "res://senior.com.br/hcm/recruitment/successfulCandidatesConsideringHierachy",
	MEDIUM_HIRING_TIME_LEADER = "res://senior.com.br/hcm/recruitment/leaderHiringAverageTimePortlet",
	LEADER_VACANCIES_BY_MONTH = "res://senior.com.br/hcm/recruitment/leaderVacancyFinishedTotalPortlet",
	FLOW_PROCESS = "res://senior.com.br/hcm/recruitment/flowProcess",
	MY_OPEN_VACANCY_TOTAL_PORTLET = "res://senior.com.br/hcm/recruitment/myOpenVacancyTotalPortlet",
	STAFF_REQUISITION_SITUATION = "res://senior.com.br/hcm/recruitment/staffRequisitionSituation",

	VIEW_VACANCY = "res://senior.com.br/hcm/vacancymanagement/entities/vacancy",
	MANAGE_VACANCIES_BY_HIERARCHY = "res://senior.com.br/hcm/vacancymanagement/manageVacanciesByHierarchy"
}

/**
 * Cards da página My, aba Recruitment
 */
export enum PermissionResourcesRecruitmentMy {
	INTERNAL_VACANCIES = "res://senior.com.br/hcm/recruitment/internalVacancies",
	MY_CANDIDATURES = "res://senior.com.br/hcm/recruitment/myInternalCandidatures",

	VIEW_VACANCY_PUBLICATION = "res://senior.com.br/hcm/vacancymanagement/entities/vacancyPublication",
}
